module.exports = __webpack_public_path__ + "static/media/imageb2c.4e02116f.webp";